// Feedback #10 — the pathname-only slice of an href, for handing to
// @lit-labs/router's goto(). Extracted to a pure function so the fix is
// unit-testable without mounting the whole cos-app element.
//
// The router matches routes with the browser's native URLPattern against
// a `{pathname: ...}` object. Chrome's implementation does NOT split a
// bare '#' out of that input the way it splits '?' — it keeps the literal
// character (percent-encoded), so a hash-suffixed href like
// `/tickets/283482#tasks` corrupts a `:id` route param into
// "283482%23tasks" (Number(...) of that is NaN) unless the hash is
// stripped first, same as the query string already was (Stage 19e).

/** The pathname portion of href, with any query string and/or hash fragment removed. */
export function routerPathOnly(href: string): string {
	return href.split(/[?#]/)[0];
}
